<div class="chat-container">
    <!-- Header -->
    <div class="header">
        <h1>Contract AI</h1>
    </div>

    <!-- Chat Window -->
    <div class="chat-window" id="chatWindow">
        <!-- <div class="message bot-message">
            {{ welcomeMessage }}
        </div>
        <div class="message bot-message">
            Welcome to Contract AI. What Contract related question can I help you with?
        </div> -->

        <!-- Empty state (only shows before the first message) -->
        <div *ngIf="messages.length === 0 && !specialBotResponse" class="empty-state">
        <div class="empty-title">{{welcomeMessage}}</div>

        <div class="empty-subtitle">
            {{ emptySubtitleText }}
        </div>

        <div class="empty-hint">
            Please read the disclaimer below.
        </div>

        <div class="empty-disclaimer">
            DISCLAIMER: Contract AI is a first-stop resource for Contract and Scheduling related questions,
            but its responses should always be checked against the Contract language. Contract Admin remains SWAPA's authority
            on Contract interpretation.
            <a href="https://www.swapa.org/globalassets/internal/documents/contract_admin/ContractAI_BetaGuide.pdf" target="_blank" rel="noopener" class="guide-button">
            Pilot User Guide
            </a>
        </div>
        </div>
        <!-- Messages will be appended here dynamically -->
        <div class="message-row" *ngFor="let msg of messages; let i = index">
            <div class="message" [ngClass]="{'user-message': msg.isUser, 'bot-message': !msg.isUser, 'loading-message': msg.text === 'loading', 'citation-message': msg.isAbbreviatedTitle, 'citation-cba': msg.isAbbreviatedTitle && msg.sourceType === 'cba', 'citation-handbook': msg.isAbbreviatedTitle && msg.sourceType === 'handbook'}">
                <ng-container *ngIf="msg.text === 'loading'; else normalMessage">
                    <div class="loading-status" role="status" aria-live="polite" aria-atomic="true">
                        <span class="loading-wheel" aria-hidden="true"></span>
                        <span class="loading-status-text">{{ loadingStatusText }}</span>
                    </div>
                </ng-container>
                <ng-template #normalMessage>
                    <!-- Display clickable abbreviated titles -->
                    <div *ngIf="msg.isAbbreviatedTitle; else normalText" (click)="openModal(msg)">
                        <button class="abbreviated-title-button">{{ msg.text }}</button>
                    </div>
                    <ng-template #normalText>
                        <!-- <div [innerHTML]="msg.text | newlineToBr"></div> -->
                        <div *ngIf="msg.isUser; else botMarkdown"
                            [innerHTML]="msg.text | newlineToBr">
                        </div>

                        <ng-template #botMarkdown>
                            <markdown
                            class="bot-markdown"
                            [data]="msg.text">
                            </markdown>
                            <div *ngIf="msg.benefitsHandoff" class="benefits-handoff">
                                <strong>
                                    {{ msg.benefitsHandoff.intro }}
                                    <a [href]="msg.benefitsHandoff.url" target="_blank" rel="noopener">{{ msg.benefitsHandoff.link_text }}</a>.
                                    {{ msg.benefitsHandoff.detail }}
                                </strong>
                            </div>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </div>
                <div *ngIf="!msg.isUser && i === mostRecentBotMessageIndex && showFeedback" class="feedback">
                    <button (click)="sendFeedback(true)" class="icon-button">
                        <span class="material-symbols-outlined">done</span>
                    </button>
                    <button (click)="showCommentSection()" class="icon-button">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                    <button class="icon-button">
                        <span (click)="showScoreForm()" class="material-symbols-outlined">indeterminate_question_box</span>
                    </button>
                </div>
                
                <!-- <div *ngIf="i === mostRecentBotMessageIndex && !msg.isUser" class="reminder">
                    Reminder: Please refresh your browser if your next question is unrelated to the one you just asked. This will help with response accuracy.
                </div>
                 -->
            
                <!-- Comment Section -->
                <div *ngIf="showComment && i === mostRecentBotMessageIndex" class="feedback-form">
                    <textarea [(ngModel)]="comment" placeholder="What about this response did you find unhelpful?" rows="3"></textarea>
                    <button (click)="submitComment()">Submit Comment</button>
                </div>

                <div *ngIf="showScore && i === mostRecentBotMessageIndex" class="score-form">
                    <label for="score">Correctness Score (1-10):</label>
                    <input
                        type="number"
                        id="score"
                        [(ngModel)]="score"
                        min="0"
                        max="10"
                        placeholder="Enter a score"
                        (change)="validateScore()"
                    />
                    <p *ngIf="scoreError" class="error">{{ scoreError }}</p>
                    <textarea
                        [(ngModel)]="comment" 
                        placeholder="Enter your comment"
                        rows="3">
                    </textarea>
                    <button (click)="sendFeedback(null, score)" class="score-submit">Submit</button>
                </div>
        </div>
        <div *ngIf="specialBotResponse" class="message bot-message">
            Is this the question you would like to submit? Or would you like to make some changes?<br><br>
            {{ specialBotResponse }}
        </div>
        <div *ngIf="showSpecialButtons" class="special-buttons">
            <button (click)="handleSubmitSpecialResponse()">Submit</button>
            <button (click)="handleEditSpecialResponse()">Edit</button>
        </div>

        <div class="modal" *ngIf="showModal">
            <div class="modal-content">
                <button class="close-btn" (click)="closeModal()">X</button>

                <!-- ===================== CBA MODAL ===================== -->

                <ng-container *ngIf="modalData.sourceType === 'cba'; else handbookModal">
                    <h2>{{ modalData.abbreviated_title }}</h2>
                    <h3 class="modal-title">{{ modalData.title }}</h3>

                    <div class="handbook-blocks" [appQuoteHighlight]="modalData.quotedTexts">
                        <div *ngFor="let b of modalData.blocks"
                            class="hb-block"
                            [class.cba-callout-block]="b.type === 'annotation' || b.type === 'grievance'">

                            <!-- Paragraph / Annotation -->
                            <div *ngIf="b.type === 'paragraph' || b.type === 'annotation'"
                                class="hb-paragraph hb-rich"
                                [class.cba-annotation]="b.type === 'annotation'"
                                [innerHTML]="(b.html || ((b.text || '') | newlineToBr)) | safeHtml">
                            </div>

                            <!-- Grievance associated with this contract section -->
                            <div *ngIf="b.type === 'grievance'"
                                class="cba-grievance hb-rich"
                                [innerHTML]="(b.html || ((b.text || '') | newlineToBr)) | safeHtml">
                            </div>

                            <!-- List -->
                            <ng-container *ngIf="b.type === 'list'">

                                <!-- Ordered -->
                                <ol *ngIf="b.ordered" class="hb-list hb-rich">
                                    <ng-container *ngIf="b.items_html?.length; else orderedPlainCba">
                                        <li *ngFor="let itemHtml of b.items_html"
                                            [innerHTML]="itemHtml | safeHtml">
                                        </li>
                                    </ng-container>

                                    <ng-template #orderedPlainCba>
                                        <li *ngFor="let item of (b.items || [])">
                                            {{ item }}
                                        </li>
                                    </ng-template>
                                </ol>

                                <!-- Unordered -->
                                <ul *ngIf="!b.ordered" class="hb-list hb-rich">
                                    <ng-container *ngIf="b.items_html?.length; else unorderedPlainCba">
                                        <li *ngFor="let itemHtml of b.items_html"
                                            [innerHTML]="itemHtml | safeHtml">
                                        </li>
                                    </ng-container>

                                    <ng-template #unorderedPlainCba>
                                        <li *ngFor="let item of (b.items || [])">
                                            {{ item }}
                                        </li>
                                    </ng-template>
                                </ul>

                            </ng-container>

                            <!-- Table -->
                            <div *ngIf="b.type === 'table'" class="cba-table-wrapper">

                                <!-- Prefer original HTML table -->
                                <div *ngIf="b.html; else cbaTableFromRows"
                                    class="cba-table-html hb-rich"
                                    [innerHTML]="b.html | safeHtml">
                                </div>

                                <!-- Fallback table rendering -->
                                <ng-template #cbaTableFromRows>
                                    <table class="cba-table">

                                        <thead *ngIf="b.rows?.length">
                                            <tr>
                                                <th *ngFor="let cell of b.rows[0]">
                                                    {{ cell }}
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr *ngFor="let row of (b.rows || []).slice(1)">
                                                <td *ngFor="let cell of row">
                                                    {{ cell }}
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </ng-template>

                            </div>

                        </div>
                    </div>
                </ng-container>

                <!-- ===================== HANDBOOK MODAL ===================== -->
                <ng-template #handbookModal>
                <h2 class="modal-title">{{ modalData.title }}</h2>

                <div class="handbook-blocks" [appQuoteHighlight]="modalData.quotedTexts">
                    <div *ngFor="let b of modalData.blocks" class="hb-block">

                    <!-- Paragraph -->
                    <div *ngIf="b.type === 'paragraph'" class="hb-paragraph hb-rich"
                        [innerHTML]="(b.html || ((b.text || '') | newlineToBr)) | safeHtml">
                    </div>

                    <!-- <div *ngIf="b.type === 'paragraph'" class="hb-paragraph">
                        {{ b.text || '' }}
                    </div> -->

                    <!-- List -->
                    <!-- <ng-container *ngIf="b.type === 'list'">
                        <ol *ngIf="b.ordered" class="hb-list">
                        <li *ngFor="let item of (b.items || [])">{{ item }}</li>
                        </ol>
                        <ul *ngIf="!b.ordered" class="hb-list">
                        <li *ngFor="let item of (b.items || [])">{{ item }}</li>
                        </ul>
                    </ng-container> -->
                    <ng-container *ngIf="b.type === 'list'">
                        <!-- ordered list -->
                        <ol *ngIf="b.ordered" class="hb-list hb-rich">
                            <ng-container *ngIf="b.items_html?.length; else orderedPlain">
                                <li *ngFor="let itemHtml of b.items_html" [innerHTML]="itemHtml | safeHtml"></li>
                            </ng-container>
                            <ng-template #orderedPlain>
                                <li *ngFor="let item of (b.items || [])">{{ item }}</li>
                            </ng-template>
                        </ol>

                        <!-- unordered list -->
                        <ul *ngIf="!b.ordered" class="hb-list hb-rich">
                            <ng-container *ngIf="b.items_html?.length; else unorderedPlain">
                                <li *ngFor="let itemHtml of b.items_html" [innerHTML]="itemHtml | safeHtml"></li>
                            </ng-container>
                            <ng-template #unorderedPlain>
                                <li *ngFor="let item of (b.items || [])">{{ item }}</li>
                            </ng-template>
                        </ul>
                    </ng-container>

                    <!-- Image -->
                    <ng-container *ngIf="b.type === 'image'">
                        <a *ngIf="b.image_url && b.link_url; else unlinkedHandbookImage"
                            [href]="b.link_url" target="_blank" rel="noopener">
                            <img class="hb-image"
                                [src]="b.image_url"
                                [alt]="b.alt || 'Scheduling handbook image'" />
                        </a>

                        <ng-template #unlinkedHandbookImage>
                            <img *ngIf="b.image_url" class="hb-image"
                                [src]="b.image_url"
                                [alt]="b.alt || 'Scheduling handbook image'" />
                        </ng-template>

                        <div *ngIf="b.image_loading" class="hb-image-status">Loading image…</div>
                        <div *ngIf="b.image_error" class="hb-image-status hb-image-error">
                            Image unavailable.
                            <a *ngIf="b.link_url" [href]="b.link_url" target="_blank" rel="noopener">
                                Open the source image
                            </a>
                        </div>
                    </ng-container>


                    </div>
                </div>
                </ng-template>

            </div>
        </div>

        <!-- Two Buttons (Displayed when form is hidden) -->
        <!-- <div *ngIf="!isFormVisible" class="button-container">
            <button (click)="resetApplication()">Ask New Question</button>
            <button (click)="showForm()">Continue Conversation</button>
        </div> -->

            <!-- *ngIf="!isFormVisible" -->
        <!-- <div class="reminder">
            DISCLAIMER: Contract AI is currently in Beta. Contract AI is a first-stop resource for Contract-related questions, but its responses should always be checked against the Contract language. Contract Admin remains SWAPA's authority on Contract interpretation. <a href="https://www.swapa.org/globalassets/internal/documents/contract_admin/ContractAI_BetaGuide.pdf" target="_blank" rel="noopener" class="guide-button">
                Pilot User Guide
            </a>
        </div> -->


    </div>



    <!-- Form LOOK AT THIS -->
    <div class="chat-input-area">
        <form class="form" (ngSubmit)="onSubmit()" #form="ngForm">
            <textarea 
            name="query" 
            placeholder="Type your question here" 
            [(ngModel)]="query" 
            #queryInput="ngModel"
            rows="1"
            required
            (input)="autoResize($event)"
            (keydown)="onKeyDown($event)">
            </textarea>

            <button class="submit-button" type="submit" [disabled]="isSubmitDisabled || form.invalid">
            Submit
            </button>

            <button *ngIf="isUserAllowed()" type="button" (click)="onSpecialSubmit()">
            Special Submit
            </button>
        </form>

        <div *ngIf="messages.length > 0" class="new-conversation-container">
            <button type="button" class="new-conversation-btn" (click)="resetApplication()">
            Start New Conversation
            </button>
        </div>
    </div>
    
</div>

<!-- (keydown.enter)="onSubmit()" -->

<!-- Splash Modal -->
<div class="modal" *ngIf="showSplash">
  <div class="modal-content">
    <button class="close-btn" (click)="closeSplash()">X</button>
    <h2 class="splash-title">Contract AI – Disclaimers and Advisories</h2>
    <p class="splash-modal-paragraph">
      Before using Contract AI, <span class="underline">it's imperative that you read the User Guide</span> to understand how the application works and its limitations.
    </p>
    <div class="splash-center-btn">
      <button class="splash-modal-btn" (click)="splashPrimaryAction()">Read User Guide</button>
    </div>
    <p class="splash-modal-paragraph">
      Contract AI is designed to help pilots quickly locate the most relevant information from the Collective Bargaining Agreement (CBA) and the Scheduling Handbook in response to contract and handbook-related questions. It is an information retrieval tool intended to help you find the information you need more efficiently—it is not a source of official contract interpretations.
    </p>
    <p class="splash-modal-paragraph">
      The Collective Bargaining Agreement is the governing contractual document. The Scheduling Handbook is a supplemental educational resource intended to explain and provide practical guidance, but it does not supersede or modify the language of the CBA. When both sources are used to answer a question, Contract AI will clearly identify which information comes from each source. Nothing generated by Contract AI represents an official position of SWAPA on any Contract issue. SWAPA Contract Administration remains the final authority on Contract interpretation.
    </p>
    <p class="splash-modal-paragraph">
      While Contract AI provides an AI-generated summary to help answer your question, its primary purpose is to direct you to the most relevant sections of the CBA and Scheduling Handbook. You should always review the cited source material before relying on any response.
    </p>
    <p class="splash-modal-paragraph">
      Always verify any information provided by Contract AI against the language of the cited supporting document. Contract AI is provided as a reference and educational tool only. The application is currently in beta and will continue to improve based on pilot feedback.
    </p>
    <div class="splash-bottom-btn">
      <button class="splash-modal-btn" (click)="splashAcknowledge()">Acknowledge</button>
    </div>
  </div>
</div>
